import { useLocation } from "react-router-dom";
import SEO from "./SEO";
import SEOConfig from "./SEOConfig";

const AboutUsSEO = () => {
  const location = useLocation();
  const { siteUrl, organization } = SEOConfig;
  const currentUrl = `${siteUrl}${location.pathname}`;

  const title = "Про нас";
  const description =
    "Slick Racing Ukraine — українська формульна ліга симрейсингу, створена у 2022 році: open wheel чемпіонати в iRacing, які проводить команда ентузіастів.";

  // Add relevant keywords for the about us page
  const keywords = [
    "Slick Racing Ukraine",
    "про нас",
    "віртуальний автоспорт",
    "симрейсинг спільнота",
    "сімрейсінг спільнота",
    "iRacing турніри",
    "українська гоночна ліга",
    "історія Slick Racing",
    "simracing",
  ];

  // Define breadcrumbs for better navigation and SEO
  const breadcrumbs = [
    {
      name: "Головна",
      url: siteUrl,
    },
    {
      name: "Про нас",
      url: currentUrl,
    },
  ];

  // The organisation itself is declared once in public/index.html; this page is about it.
  const schema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: title,
    description,
    url: currentUrl,
    inLanguage: "uk",
    mainEntity: { "@id": organization.id },
  };

  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      url={currentUrl}
      schema={schema}
      canonical={currentUrl}
      type="website"
      breadcrumbs={breadcrumbs}
      lang="uk"
    />
  );
};

export default AboutUsSEO;
